import React, { useEffect, useState } from 'react';
import { getBPSSchedule, setBPSSchedule } from '../services/configurationService';
import { Box, Button, Checkbox, FormControlLabel, Grid, Typography, TextField } from '@mui/material';

const BPSScheduleConfig = () => {
    const [schedule, setSchedule] = useState({
        startTime: '09:00',
        endTime: '19:00',
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: false,
        sunday: false,
    });

    useEffect(() => {
        const loadSchedule = async () => {
            try {
                const data = await getBPSSchedule();
                setSchedule(data);
            } catch (error) {
                console.error('Error loading BPS schedule:', error);
            }
        };
        loadSchedule();
    }, []);

    const handleTimeChange = (field) => (event) => {
        setSchedule(prev => ({
            ...prev,
            [field]: event.target.value
        }));
    };

    const handleDayChange = (field) => (event) => {
        setSchedule(prev => ({
            ...prev,
            [field]: event.target.checked
        }));
    };

    const handleSave = async () => {
        try {
            await setBPSSchedule(schedule);
            alert('Horario guardado correctamente');
        } catch (error) {
            console.error('Error saving BPS schedule:', error);
            alert('Error al guardar el horario');
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
                Configuración de Horario BPS
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Hora de inicio"
                        type="time"
                        value={schedule.startTime}
                        onChange={handleTimeChange('startTime')}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            step: 300 // 5 minutos
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Hora de fin"
                        type="time"
                        value={schedule.endTime}
                        onChange={handleTimeChange('endTime')}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            step: 300 // 5 minutos
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                        Días habilitados
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={schedule.monday}
                                        onChange={handleDayChange('monday')}
                                    />
                                }
                                label="Lunes"
                            />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={schedule.tuesday}
                                        onChange={handleDayChange('tuesday')}
                                    />
                                }
                                label="Martes"
                            />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={schedule.wednesday}
                                        onChange={handleDayChange('wednesday')}
                                    />
                                }
                                label="Miércoles"
                            />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={schedule.thursday}
                                        onChange={handleDayChange('thursday')}
                                    />
                                }
                                label="Jueves"
                            />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={schedule.friday}
                                        onChange={handleDayChange('friday')}
                                    />
                                }
                                label="Viernes"
                            />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={schedule.saturday}
                                        onChange={handleDayChange('saturday')}
                                    />
                                }
                                label="Sábado"
                            />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={schedule.sunday}
                                        onChange={handleDayChange('sunday')}
                                    />
                                }
                                label="Domingo"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                        sx={{ mt: 2 }}
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default BPSScheduleConfig; 